<template>
    <li class="list-group-item">
      <div class='d-flex flex-row justify-content-between align-items-center cursor-pointer' v-on:click="expanded = !expanded">
        <div class="expand-btn">
            <i 
                v-show="expanded" 
                class='far fa-bold fa-chevron-down'>
            </i>
            <i 
                v-show="!expanded" 
                class='far fa-bold fa-chevron-right'>
            </i>
        </div>
        <slot name="header">
            <h3>Default Header</h3>
        </slot>
    </div>
  
      <div class='d-flex flex-column' v-if="expanded">
        <slot name="body">
            Default Body
        </slot>
      </div>
    </li>
  </template>
  
  <script>
    
  export default {

    props: {
      initiallyExpanded: {
        type: Boolean,
        default: false // Default value is true, meaning the accordion will be expanded initially
      }
    },
  
    data: function () {
      return {
        expanded: this.initiallyExpanded,
      };
    },
  }
  
  </script>
  
  <style scoped>
    i {
      cursor: pointer;
    }
  </style>